import { getInitials } from "src/utils/getInitials";
import { monogramTone } from "src/stage/StageUi";

export function ContactAvatar({ contact, size = "normal" }) {
  const initials = getInitials(contact);

  const sizeClasses = size === "small" ? "h-8 w-8 rounded-full text-[9px] sm:h-9 sm:w-9 sm:text-[10px]" : "h-9 w-9 rounded-full text-[10px] sm:h-11 sm:w-11 sm:text-[12px]";
  return (
    <div className="relative shrink-0">
      <div className="absolute inset-1 rounded-full bg-primary/5 blur-[6px] sm:blur-[8px]" />
      <div className={["relative flex items-center justify-center overflow-hidden", "font-semibold", sizeClasses, "text-white", "shadow-[0_3px_8px_-4px_rgba(16,47,69,0.45)]",].join(" ")} style={{ background: monogramTone(initials).background }}>
        <span className="pointer-events-none absolute left-1 top-1 h-2.5 w-6 rounded-full bg-white/25 blur-[3px] sm:h-3 sm:w-7" />
        <span className="pointer-events-none absolute inset-0 bg-[radial-gradient(circle_at_30%_20%,rgba(255,255,255,0.28),transparent_42%)]" />
        <span className="pointer-events-none absolute -right-2.5 -top-2.5 h-8 w-8 rounded-full bg-white/10 blur-[7px] sm:-right-3 sm:-top-3 sm:h-9 sm:w-9 sm:blur-[8px]" />
        <span className="relative z-10 select-none tracking-[-0.02em]">
          {initials}
        </span>
      </div>
      {/* Online indicator */}
      <span className="absolute -bottom-0.5 -right-0.5 z-20 flex h-3 w-3 items-center justify-center rounded-full border-[1.5px] border-white bg-primary shadow-[0_1px_2px_rgba(71,91,105,0.08)] sm:h-[13px] sm:w-[13px] sm:border-2">
        <span className="h-[3px] w-[3px] rounded-full bg-white sm:h-[4px] sm:w-[4px]" />
      </span>
    </div>
  );
}